import { BaseLayout } from "layouts/common/BaseLayout";
import { InsideLayoutProvider } from "layouts/common/inside/InsideLayoutProvider";
import * as React from "react";
import { PropsWithChildren } from "react";
import { Outlet } from "react-router";
import { LmsMenu } from "./LmsMenu";

////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IAppProps {
    fullView?: boolean;
}

type Props = IAppProps & PropsWithChildren;

////////////////////////////////////////////////////////////////////////////////////////////////////////

export const LmsLayout: React.FC<Props> = (props) => {
    return (
        <BaseLayout>
            <InsideLayoutProvider
                lateralMenu={<LmsMenu />}
                showCloseButtonWhileMenuOpened={false}
                subHeaderAlwaysVisible={true}
            >
                <Outlet />
            </InsideLayoutProvider>
        </BaseLayout>
    );
};
